import React, { Component } from "react";
import IncomeTypeList from "./IncomeTypeList";
import IncomeTypeAddEdit from "./IncomeTypeAddEdit";

class IncomeType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return <IncomeTypeList onClick={this.handleClick} />;
    } else {
      return (
        <IncomeTypeAddEdit
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ data, mode });
  }
}

export default IncomeType;
